// extracted by mini-css-extract-plugin
export default {"tableRowContainer":"ApplicationsTableSkeletonRow_tableRowContainer__oIT1C","tableRowContainerInactive":"ApplicationsTableSkeletonRow_tableRowContainerInactive__M53NL"};